import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import styles from './Navbar.module.css';

const openInquiryForm = () => {
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#form`);
  window.dispatchEvent(new HashChangeEvent('hashchange'));
};

const links = [['section0', 'Начало'], ['section1', 'За нас'], ['section2', 'Услуги'], ['section3', 'Контакти']];

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => { const update = () => setIsScrolled(window.scrollY > 16); window.addEventListener('scroll', update, { passive: true }); return () => window.removeEventListener('scroll', update); }, []);
  const closeMenu = () => setIsMenuOpen(false);
  return <nav className={`${styles.navbar} ${isScrolled ? styles.scrolled : ''}`}>
    <div className={styles.inner}>
      <Link to="section0" smooth duration={700} className={styles.brand} onClick={closeMenu} aria-label="Geoworld - начало"><span>GEO</span><strong>WORLD</strong></Link>
      <div className={styles.navLinks}>{links.map(([target, label]) => <Link key={target} to={target} smooth spy offset={-72} duration={700} activeClass={styles.active} className={styles.navLink}>{label}</Link>)}<button type="button" className={styles.requestButton} onClick={openInquiryForm}>Запитване <span>→</span></button></div>
      <button type="button" className={styles.menuButton} onClick={() => setIsMenuOpen(value => !value)} aria-expanded={isMenuOpen} aria-label="Отвори меню"><i /><i /></button>
    </div>
    {isMenuOpen && <div className={styles.mobileMenu}>{links.map(([target, label]) => <Link key={target} to={target} smooth offset={-65} duration={700} className={styles.mobileLink} onClick={closeMenu}>{label}</Link>)}<button type="button" className={styles.mobileRequest} onClick={() => { closeMenu(); openInquiryForm(); }}>Изпратете запитване</button></div>}
  </nav>;
};
export default Navbar;
